function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import __NS_DYNAMIC_REACT_CONTENT___0 from "./acp-biometrics-failure.strings/content.default.js";
import { Content, createScopedReactContentImporter } from "packages/react-content/runtime";
const NS_DYNAMIC_REACT_CONTENT_MANAGER = createScopedReactContentImporter(undefined, {
  "default": () => __NS_DYNAMIC_REACT_CONTENT___0
});
import { createElement } from 'react';
import { Body, Title } from 'legos/typography';
import { ContentBlock } from 'legos/content-block';
import { ButtonRaised } from 'legos/button/raised';
import { EnrollmentContainer, HeadingContainer, ChangeOrDisable } from './styles/acp-biometrics-intoduction-success-failure.ccm.css';
import { InPageFlowLayout } from 'legos/in-page-flow-layout';
import { CenterChildren } from '../components';
import { Illustration } from 'legos/illustration';
import { BiometricsSecurityPathDashboard } from './biometrics-security-path-content';
export const BiometricsFailure = ({
  title,
  cancelAnchor,
  biometricsType,
  dashboardMfeEnabled,
  loginPreferencesMfeEnabled
}) => {
  const titleContent = biometricsType === 'touch' ? createElement(Content, {
    hash: "e871b0059c7114c04a1127173dbe674b",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }) : createElement(Content, {
    hash: "9d73f027d4f87e9695505c744f8b67a0",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  });
  return createElement(InPageFlowLayout, {
    title: title,
    cancelAnchor: cancelAnchor
  }, createElement(ContentBlock, null, createElement(EnrollmentContainer.div, null, createElement(Illustration, {
    type: "general-error",
    label: "image illustrating error"
  }), createElement(HeadingContainer.div, null, createElement(Title, null, titleContent)), createElement(ChangeOrDisable.div, null, createElement(Body, null, createElement(Content, {
    hash: "479a32ab389a0cd2f76c54276cddc1d6",
    devVariables: {},
    componentsAndExpressions: [() => biometricsType === 'touch' ? 'Fingerprint' : 'Face ID'],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }), createElement(BiometricsSecurityPathDashboard, {
    dashboardMfeEnabled: dashboardMfeEnabled,
    loginPreferencesMfeEnabled: loginPreferencesMfeEnabled
  }))), createElement(CenterChildren, null, createElement(ButtonRaised, _extends({
    color: "positive"
  }, cancelAnchor), createElement(Content, {
    hash: "5f120f311d800b722b5506b80649e66a",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }))))));
};